import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { PieChart } from "@mui/x-charts";

const UserAnalytics = () => {
  // Mock data
  const userData = [
    { id: 1, name: "New Users", value: 500 },
    { id: 2, name: "Returning Users", value: 300 },
    { id: 3, name: "Inactive Users", value: 200 },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        User Analytics
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 6}}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                User Distribution
              </Typography>
              <PieChart
                series={[
                  {
                    data: userData,
                    innerRadius: 30,
                    outerRadius: 100,
                    paddingAngle: 5,
                    cornerRadius: 5,
                  },
                ]}
                height={300}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserAnalytics;